module.exports = __webpack_public_path__ + "media/images/koala-submark-53ea7d44ec56af61a5873c4d3835a89d.svg";